import { Box, Group, UnstyledButton, Text } from '@mantine/core';
import {
  IconHome2,
  IconFolder,
  IconMessageCircle,
  IconSettings,
  IconCoin,
} from '@tabler/icons-react';
import { Link, useRouterState } from '@tanstack/react-router';

interface NavTab {
  label: string;
  icon: typeof IconHome2;
  to: string;
  matchPrefixes: string[];
}

const tabs: NavTab[] = [
  {
    label: 'Dashboard',
    icon: IconHome2,
    to: '/portal/dashboard',
    matchPrefixes: ['/portal/dashboard'],
  },
  {
    label: 'Finances',
    icon: IconCoin,
    to: '/portal/reconciliation',
    matchPrefixes: [
      '/portal/reconciliation',
      '/portal/bookkeeping',
      '/portal/reports',
      '/portal/payroll',
      '/portal/tax-timeline',
    ],
  },
  {
    label: 'Documents',
    icon: IconFolder,
    to: '/portal/documents',
    matchPrefixes: ['/portal/documents'],
  },
  { label: 'Chat', icon: IconMessageCircle, to: '/portal/chat', matchPrefixes: ['/portal/chat'] },
  {
    label: 'Settings',
    icon: IconSettings,
    to: '/portal/settings',
    matchPrefixes: ['/portal/settings', '/portal/notifications'],
  },
];

export function PortalBottomNav() {
  const routerState = useRouterState();
  const currentPath = routerState.location.pathname;

  return (
    <Box
      component='nav'
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 200,
        height: 64,
        backgroundColor: 'var(--mantine-color-body)',
        borderTop: '1px solid var(--mantine-color-default-border)',
        paddingBottom: 'env(safe-area-inset-bottom, 0px)',
      }}
    >
      <Group
        h={64}
        justify='space-around'
        wrap='nowrap'
        style={{ maxWidth: 640, margin: '0 auto' }}
      >
        {tabs.map(tab => {
          const isActive = tab.matchPrefixes.some(prefix => currentPath.startsWith(prefix));
          const Icon = tab.icon;

          return (
            <UnstyledButton
              key={tab.to}
              component={Link}
              to={tab.to}
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minWidth: 44,
                minHeight: 44,
                flex: 1,
                gap: 2,
              }}
            >
              <Icon
                size={24}
                stroke={isActive ? 2 : 1.5}
                color={
                  isActive ? 'var(--mantine-color-brand-filled)' : 'var(--mantine-color-gray-6)'
                }
              />
              <Text
                size='xs'
                fw={isActive ? 600 : 400}
                c={isActive ? 'brand' : 'gray.6'}
                style={{ lineHeight: 1.2 }}
              >
                {tab.label}
              </Text>
            </UnstyledButton>
          );
        })}
      </Group>
    </Box>
  );
}
